<template>
  <div
    id="editor-middle"
    class="flex-col flex-1 flex"
    :class="{
      'middle-presentation': true,
      'presenting-mode': $store.getters.isPresenting,
      'transparent-bg': $store.state.slideActive.type == 'image' &&
        $store.state.slideActive.imageType == 'background',
      'playing-demo': isPlayDemoMode,
      'middle-ppt-full': isEnableAddinPowerpoint,
    }"
    v-prevent-wheel-propagation="{ throttleTime: WHEEL_THROTTLE_TIME }"
  >
    <!-- <div
     class="overlay-powerpoint-add-in"
     v-if="isOpenEditSlidePowerPoint"
     @click="closeEdit()"
   ></div> -->
    <div
      class="exit-wrapper"
      @click="mobileExitFullScreen"
      v-if="$store.getters.isPresenting && !isMSTeamsApp && !isEnableAddinPowerpoint"
    >
      <i class="fas fa-times" />
      <span>{{ $i18nPresenter.t('Exit') }}</span>
    </div>
    <TakeOverToolbar v-if="isTakeOverToolbarVisible" class="take-over" id="middle-take-over-toolbar" />
    <ContentSlideToolbar />
    <ContentAddInPPT
      v-if="showAddInPPT && !canRemovePowerPointButton"
      :type="slideActive.type"
      :slideType="slideActive.slideType"
      :class="{'invisible' : invisibleAddInPPT}"
    />
    <ContentAddInPPTWithoutPowerPoint
      v-if="showAddInPPT && canRemovePowerPointButton"
      :type="slideActive.type"
      :slideType="slideActive.slideType"
      :class="{'invisible' : invisibleAddInPPT}"
    />
    <div
      class="slide-intro"
      :class="{
        [$store.state.currentSlideCanvas]: true,
        'flex flex-col': !isPresenting,
      }"
      id="middle-slide-intro"
    >
      <div
        class="ahaslide-legacy-css wrap-slide-intro"
        :class="{'fit': isPresenting, 'is-backstage': isBackstage}"
        id="middle-canvas"
      >
        <SlideWrapper
          @selectPrevSlide="selectPrevSlide"
          @selectNextSlide="selectNextSlide"
          @handleNextSlideWhenPlayingQuiz="handleNextSlideWhenPlayingQuiz"
        />
      </div>

      <div
        v-if="!isBackstage"
        :class="{'powerpoint-middle flex flex-col items-center': isEnableAddinPowerpoint}"
        id="ppt-middle"
      >
        <LimitSlideByPlan
          v-if="planBenefit.name === 'free' &&
            (planBenefitLimitation.poll || planBenefitLimitation.quiz)"
        />
        <MiddleYouCanHostUpTo
          :class="{'flex-grow': isEnableAddinPowerpoint}"
          v-else
        />
        <div
          :class="{'active': $store.state.showLiveAudienceDemo}"
          class="text-center audience-mode horizontal layout center"
          v-if="!isEnableAddinPowerpoint"
        >
          <ParticipantViewButton
            v-if="presentation.id"
            class="mr-2"
          />

          <ResetResultsButton
            gaAction="Editor"
            v-if="presentation.id"
          />
        </div>
      </div>

      <BackstageSlideButtons
        v-if="isBackstage && !isPresentingPpt"
        @selectPrevSlide="selectPrevSlide"
        @selectNextSlide="selectNextSlide"
      />

      <SlideNotes v-if="!isEnableAddinPowerpoint" />
    </div>
  </div>
</template>
<script>
import screenfull from 'screenfull'
import interact from 'interactjs'
import { mapState, mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import SlideNotes from './SlideNotes.vue'
import BackstageSlideButtons from '@/components-v2/presentation-editor/middle/BackstageSlideButtons.vue'
import SlideWrapper from '@/components-v2/presentation-editor/middle/SlideWrapper.vue'
import TakeOverToolbar from '@/components-v2/presentation-editor/TakeOverToolbar.vue'
import ContentSlideToolbar from '@/components-v2/presentation-editor/middle/ContentSlideToolbar.vue'
import ContentAddInPPT from '@/components-v2/presentation-editor/middle/ContentAddInPPT.vue'
import ContentAddInPPTWithoutPowerPoint from '@/components-v2/presentation-editor/middle/ContentAddInPPTWithoutPowerPoint.vue'

import config from '@/config'
import EventBus from '@/eventBus'
import constants from '@/constant'
import QuizStatuses from '@/constant/QuizStatuses'

import util from '@/util'
import Socket from '@/socket'
import UserApi from '@/api/user'
import { WHEEL_THROTTLE_TIME } from '@/constant/fixedTime'

// components
import ResetResultsButton from '@/components-v2/common/reset-results/ResetResultsButton.vue'
import ParticipantViewButton from '@/components-v2/presentation-editor/middle/ParticipantViewButton.vue'
import MiddleYouCanHostUpTo from '@/components-v2/presentation-editor/middle/MiddleYouCanHostUpTo.vue'
import LimitSlideByPlan from '@/components-v2/presentation-editor/middle/LimitSlideByPlan.vue'

// services
import cookie from '@/services/cookie'
import zoho from '@/services/zoho'

import {
  SET_CURRENT_SLIDE_MODE,
} from '@/vuex/types'

export default {
  components: {
    ResetResultsButton,
    ParticipantViewButton,
    SlideNotes,
    MiddleYouCanHostUpTo,
    BackstageSlideButtons,
    SlideWrapper,
    TakeOverToolbar,
    ContentSlideToolbar,
    ContentAddInPPT,
    ContentAddInPPTWithoutPowerPoint,
    LimitSlideByPlan,
  },
  data() {
    return {
      isMSTeamsApp: !!util.getParamValue('ms-teams', window.location.href),
      debouceTimeNextSlide: null,
      presentationCopyId: null,
      timer: null,
      typeChart: '',
      isGuestUser: !!cookie.getValue('aha-guest-user'),
      QuizStatuses,
      notes: '',
      isClaimingFreeOneTimeOffer: false,
      notAllowShowSlideType: [
        'freestyle',
        'textSlide',
        'image',
      ],
      WHEEL_THROTTLE_TIME,
    }
  },
  computed: {
    ...mapGetters('zoomApp', [
      'isZoomReady',
    ]),
    ...mapGetters('collaboration', ['isTakeOverToolbarVisible']),
    ...mapGetters('featureToggles', ['canRemovePowerPointButton']),
    ...mapState({
      showingSlideGrid: (state) => state.indicators.showingSlideGrid,
      isScreenCapture: (state) => state.isScreenCapture,
      activeSlideId: (state) => state.activeSlideId,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      canEditPresentation: (state) => state.canEditPresentation,
      presentation: (state) => state.presentation,
      isPlayDemoMode: (state) => state.isPlayDemoMode,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      isNewPresentation: (state) => state.isNewPresentation,
      presentationEditors: (state) => state.presentationEditors,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      isOpenEditSlidePowerPoint: (state) => state.isOpenEditSlidePowerPoint,
      activePresentationPowerpointId: (state) => state.activePresentationPowerpointId,
      planBenefit: (state) => state.planBenefit,
      planBenefitLimitation: (state) => state.planBenefitLimitation,
      isSharingView: (state) => state.sharePresentation,
    }),
    ...mapGetters('presentationChat', ['isFocusingChatInput']),
    ...mapGetters(['isPresenting', 'isBackstage']),

    tip: () => config.PRO_TIPS[
      util.randomIntFromInterval(0, config.PRO_TIPS.length - 1)
    ],

    hasPrevSlide() {
      return this.$store.getters.currentSlideIndex > 0
    },
    hasNextSlide() {
      return (
        this.$store.getters.currentSlideIndex <
        this.$store.state.presentation.slides.length - 1
      )
    },

    isHideTextShare() {
      return !!util.getParamValue('hideText', window.location.href)
    },

    showAddInPPT() {
      if (config.region === 'eu') return false
      if (this.isBackstage) return false
      if (!this.canEditPresentation) return false
      if (this.notAllowShowSlideType.includes(this.slideActive.type)) return false
      if (this.isEnableAddinPowerpoint) return false
      return true
    },
    invisibleAddInPPT() {
      if (this.presentation.User && (this.presentation.User.id === this.currentUser.id)) {
        return false
      }
      return true
    },
    isPresentingPpt() {
      if (this.isEnableAddinPowerpoint && this.isPresenting) return true
      return false
    },
    isQuizAtLobby() {
      return this.slideActive.type == constants.SLIDE_TYPE.PICK_ANSWER &&
        this.slideActive.quizStatus === constants.QuizStatuses.LOBBY_SCREEN
    },
  },
  watch: {
    '$store.getters.isPresenting': function watchIsPresenting(isPresenting) {
      if (isPresenting) {
        document.body.classList.add('no-scroll')
        document.body.classList.add('body-presenting')
        zoho.hideChatBtn()
        this.requestWakeLockAction()
      } else {
        const { presentation } = this.$store.state
        if (presentation.showBranding || presentation.showExport ||
        presentation.showSetting || presentation.showShare) {
          document.body.classList.remove('body-presenting')
        } else {
          document.body.classList.remove('no-scroll')
          document.body.classList.remove('body-presenting')
        }

        // when exit presenting mode
        if (this.$store.state.slideActive.type === 'pickAnswer') {
          this.updateSlideActiveAction({
            quizStatus: constants.QuizStatuses.LOBBY_SCREEN,
            hideResult: false,
            showCorrectOption: true,
          })
        }
        zoho.showChatBtn()
        this.releaseWakeLockAction()
      }

      if (this.$store.state.continueQuiz) {
        this.$store.state.continueQuiz = false
      }
      if (!this.isEnableAddinPowerpoint) {
        this.$store.state.presentation.presenting = isPresenting
      }
    },
  },
  destroyed() {
    EventBus.$off('template-preview:go-to-slide', this.goToSlide)
    if (window.innerWidth > 800) {
      if (screenfull && screenfull.off) {
        screenfull.off('change')
      }
    }

    this.$store.dispatch(SET_CURRENT_SLIDE_MODE, '')
    document.body.classList.remove('no-scroll')
    document.body.classList.remove('body-presenting')
    this.$store.state.planBenefitLimitation = {}
  },

  mounted() {
    EventBus.$on('template-preview:go-to-slide', this.goToSlide)
    this.handleShowControlsOnHoverDevices()
    this.handleShowControlsOnTouchDevices()
    this.initWheelScrollAction(this.$el)

    const self = this

    if (window.innerWidth >= 800) {
      if (!screenfull || !screenfull.on) return
      screenfull.on('change', () => {
        EventBus.$emit('context-menu: update showContextMenu', false)
        if (!this.isMSTeamsApp && !screenfull.isFullscreen && self.$store.getters.isPresenting
          && !self.$store.getters.isWindowedMode) {
          util.setCurrentWindowMode()
          this.$http.put(
            config.api.updatePresentation + this.$store.state.presentation.id,
            {
              presenting: false,
              socketId: Socket.getSocketId(),
              accessCode: this.$store.state.presentation.uniqueAccessCode,
            },
          )
          this.$router.replace({
            name: 'PresentationDetail',
            params: { id: this.$store.state.presentation.id },
          })
        }
      })
    }

    function endDrag(event) {
      const { target } = event
      target.classList.remove('draging')
    }
    interact('.live-demo-audience').draggable({
      // enable inertial throwing
      inertia: true,
      // keep the element within the area of it's parent
      // enable autoScroll
      autoScroll: true,

      // call this function on every dragmove event
      // eslint-disable-next-line no-use-before-define
      onmove: dragMoveListener,
      // call this function on every dragend event
      onend: endDrag,
    })

    function dragMoveListener(event) {
      const { target } = event
      // keep the dragged position in the data-x/data-y attributes
      const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
      const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

      // translate the element
      if (!self.enableABtestParticipeatView) {
        target.style.transform = `scale(0.8) translate(${x}px, ${y}px)`
      } else {
        target.style.transform = `scale(0.65) translate(${x}px, ${y}px)`
      }
      target.style.webkitTransform = target.style.transform

      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
      target.classList.add('draging')
    }

    // this is used later in the resizing and gesture demos
    window.dragMoveListener = dragMoveListener

    const isEmbed = util.getParamValue('embedded')
    if (isEmbed) {
      this.$store.state.isPlayDemoMode = true
      document.body.classList.add('playing-demo-body')
    }
  },
  methods: {
    ...mapActions([
      'updateSlideActiveAction',
      'setCurrentUserAction',
    ]),
    ...mapActions('zoomApp', [
      'detachPresentationToZoomMeetingAction',
    ]),
    ...mapActions('wheelEvent', ['initWheelScrollAction']),

    ...mapActions('preventLockScreen', [
      'requestWakeLockAction',
      'releaseWakeLockAction',
    ]),

    _checkShowingAnimationImgSlideBackground() {
      const { isPresenting } = this.$store.getters

      if (this.imageSlideBackgroundVisible && isPresenting) {
        this.showingAnimationImgSlideBackground = true
      } else if (this.imageSlideBackgroundVisible && !isPresenting) {
        this.showingAnimationImgSlideBackground = false
      }
    },
    checkBulletPointsPresenting(isPresenting) {
      if (this.$store.state.slideActive.type == 'bulletPoints') {
        const options = []
        this.$store.state.slideActive.SlideOptions.forEach((item) => {
          if (item.title) {
            options.push(item)
          }
        })

        if (!options.length) {
          if (isPresenting) {
            this.updateSlideActiveAction({
              SlideOptions: options,
            })
          } else {
            this.updateSlideActiveAction({
              SlideOptions: [
                {
                  index: 1,
                  order: 1,
                },
                {
                  index: 2,
                  order: 2,
                },
                {
                  index: 3,
                  order: 3,
                },
              ],
            })
          }
        } else if (isPresenting) {
          this.updateSlideActiveAction({
            SlideOptions: options,
          })
        }
      }
    },

    handleNextSlideWhenPlayingQuiz(type) {
      if (type === 'next') {
        this._autoNextSlide('keyboard')
      }

      if (type === 'prev') {
        this._autoPrevSlide('keyboard')
      }
    },
    handleShowControlsOnHoverDevices() {
      if (util.supportsTouch()) return
      this.$el.addEventListener('mousemove', () => {
        this.handleShowSlideControls()
      })
    },

    handleShowControlsOnTouchDevices() {
      if (!util.supportsTouch()) return
      this.$el.addEventListener('touchstart', () => {
        this.handleShowSlideControls()
      })
    },

    handleShowSlideControls() {
      if (this.isPresenting) {
        EventBus.$emit('next-back-slide-arrows: update isShowingControls', true)
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            EventBus.$emit('next-back-slide-arrows: update isShowingControls', false)
          }, config.SLIDE_CONTROLS_TIMEOUT)
        } else {
          this.timer = setTimeout(() => {
            EventBus.$emit('next-back-slide-arrows: update isShowingControls', false)
          }, config.SLIDE_CONTROLS_TIMEOUT)
        }
      }
    },

    _getCurrentIndexSlide(currentSlideId) {
      return this.$store.state.presentation.slides.findIndex((item) => {
        return item.id == currentSlideId
      })
    },
    selectPrevSlide(mode) {
      if (this.isEnableAddinPowerpoint && !this.activePresentationPowerpointId) return

      // Rem Confirm Modal Exit Quiz
      // if (this.$store.state.slideActive.type == 'pickAnswer'
      //   && this.$store.state.slideActive.quizStatus != constants.QuizStatuses.LOBBY_SCREEN
      //   && this.$store.state.slideActive.quizStatus != constants.QuizStatuses.RESULT_SCREEN) {
      //   const index = this.$store.state.presentation.slides.findIndex((item) => {
      //     return item.id == this.$store.state.slideActive.id
      //   })
      //   if (index === 0) {
      //     return
      //   }
      //   this.$store.state.quizConfirmation = true
      //   this.$store.state.quizConfirmationType = 'prev'
      //   util.mixpanelTracking(
      //     'Quiz Exit Confirmation',
      //     'Quiz Exit Confirmation open modal',
      //     'Quiz Exit Confirmation open modal prev',
      //   )
      //   util.uploadSlide(
      //     this.$store.state.slideActive,
      //     this.$store.state.presentation,
      //   )
      //   return
      // }
      if (
        mode != 'icon-arrow-right' &&
        mode != 'icon-arrow-left' &&
        mode != 'swipe'
      ) {
        if (!this.checkShowAllBulletPoints('prev')) {
          EventBus.$emit('next-back-slide: update-bulletPointsIndex', this.checkShowAllBulletPoints('prev'), 'prev')
          return
        }
      }

      if (!this.hasPrevSlide) return
      this._autoPrevSlide(mode)
    },

    _autoPrevSlide(mode) {
      this.$store.state.controllerSocketId = Socket.getSocketId()

      const oldSlide = JSON.parse(JSON.stringify(this.$store.state.slideActive))
      const currentSlideId = oldSlide.id
      this.$store.dispatch('updateSlideActive', {
        id: null,
      })
      if (this.$store.state.continueQuiz) {
        this.$store.state.continueQuiz = false
      }
      this.$store.state.transitionContent = ''
      setTimeout(() => {
        if (!currentSlideId) return
        const item = this.$store.state.presentation.slides[
          this._getCurrentIndexSlide(currentSlideId) - 1
        ]
        if (this.$store.state.activePresentationPowerpointId) {
          this.$store.state.presentation.activeSlide = item.id
        }
        this.$store.dispatch('setSlideActive', item)
        EventBus.$emit('updateNextSlide', item.id)

        this.$store.state.transitionContent = 'left'
        EventBus.$emit('changeShowingAnimationClass', true)
        EventBus.$emit('checkShowingAnimationImgSlideBackground')
        EventBus.$emit('setValueForTransition')
        EventBus.$emit('updateValueWhenTransitionEnds')
      }, 0)
      this.$store.state.countReconnectSocket = 0
      util.mixpanelTracking(
        constants.eventCategories.PRESENTING_MODE,
        `Presentation > Presenting > Previous slide using ${mode}`,
        null,
        null,
        {
          qrCodeOpening: this.$store.state.isQRCodeVisible,
        },
      )
    },
    checkShowAllBulletPoints(mode) {
      const {
        type, showAllBulletPoints, SlideOptions, bulletPointsIndex,
      } = this.slideActive
      if (type !== 'bulletPoints' || showAllBulletPoints) return true
      if (mode == 'next') {
        if (SlideOptions && SlideOptions.length > bulletPointsIndex) return false
        return true
      }
      if (mode == 'prev') {
        if (!bulletPointsIndex) return true
        return false
      }
      return true
    },

    selectNextSlide(mode) {
      if (this.isEnableAddinPowerpoint && !this.activePresentationPowerpointId) return
      if (mode != 'keyboard') {
        this.$store.state.historyKeyboard = null
      }
      // Rem Confirm Modal Exit Quiz
      // if (this.$store.state.slideActive.type == 'pickAnswer'
      //   && this.$store.state.slideActive.quizStatus != constants.QuizStatuses.LOBBY_SCREEN
      //   && this.$store.state.slideActive.quizStatus != constants.QuizStatuses.RESULT_SCREEN
      //   && this.$store.state.slideActive.id != this.$store.state.presentation.lastSlide) {
      //   this.$store.state.quizConfirmation = true
      //   this.$store.state.quizConfirmationType = 'next'
      //   util.mixpanelTracking(
      //     'Quiz Exit Confirmation',
      //     'Quiz Exit Confirmation open modal',
      //     'Quiz Exit Confirmation open modal next',
      //   )

      //   util.uploadSlide(
      //     this.$store.state.slideActive,
      //     this.$store.state.presentation,
      //   )
      //   return
      // }

      if (this.isQuizAtLobby) {
        EventBus.$emit('start-quiz')
        return
      }

      if (
        mode != 'icon-arrow-right' &&
        mode != 'icon-arrow-left' &&
        mode != 'swipe'
      ) {
        if (!this.checkShowAllBulletPoints('next')) {
          EventBus.$emit('next-back-slide: update-bulletPointsIndex', this.checkShowAllBulletPoints('next'), 'next')
          return
        }
      }
      if (!this.hasNextSlide) return
      this._autoNextSlide(mode)
    },

    _autoNextSlide(mode) {
      this.$store.state.controllerSocketId = Socket.getSocketId()

      const oldSlide = JSON.parse(JSON.stringify(this.$store.state.slideActive))
      const currentSlideId = oldSlide.id

      this.$store.dispatch('updateSlideActive', {
        id: null,
      })
      this.$store.state.transitionContent = ''
      setTimeout(() => {
        if (!currentSlideId) return
        const nextIndex = this._getCurrentIndexSlide(currentSlideId) + 1
        const item = this.$store.state.presentation.slides[nextIndex]
        if (this.$store.state.activePresentationPowerpointId) {
          this.$store.state.presentation.activeSlide = item.id
        }
        this.$store.dispatch('setSlideActive', item)
        this.$store.state.transitionContent = 'right'
        EventBus.$emit('changeShowingAnimationClass', true)
        EventBus.$emit('checkShowingAnimationImgSlideBackground')
        EventBus.$emit('setValueForTransition')
        EventBus.$emit('updateValueWhenTransitionEnds')

        // Handle preload images, etc
        this.$emit('nextSlideHandler', nextIndex)
        EventBus.$emit('updateNextSlide', item.id)
        this._handleUpdateLiveDemoLastSlide(nextIndex, this.$store.state.presentation.slides.length)
      }, 0)
      this.$store.state.countReconnectSocket = 0
      util.mixpanelTracking(
        constants.eventCategories.PRESENTING_MODE,
        `Presentation > Presenting > Next slide using ${mode}`,
        null,
        null,
        {
          qrCodeOpening: this.$store.state.isQRCodeVisible,
        },
      )
    },

    goToSlide(currentSlideId) {
      this.$store.state.transitionContent = ''
      this.$store.dispatch('updateSlideActive', {
        id: null,
      })
      setTimeout(() => {
        if (!currentSlideId) return
        const index = this.$store.state.presentation.slides.findIndex((slide) => {
          return slide.id == currentSlideId
        })
        const item = this.$store.state.presentation.slides[index]
        if (!item) return
        this.$store.dispatch('setSlideActive', item)
        this.$store.state.transitionContent = 'right'
        EventBus.$emit('changeShowingAnimationClass', true)
        EventBus.$emit('checkShowingAnimationImgSlideBackground')
        EventBus.$emit('setValueForTransition')
        EventBus.$emit('updateValueWhenTransitionEnds')

        // Handle preload images, etc
        this.$emit('nextSlideHandler', index)
        EventBus.$emit('updateNextSlide', item.id)
        this._handleUpdateLiveDemoLastSlide(index, this.$store.state.presentation.slides.length)
      }, 0)
    },

    _handleUpdateLiveDemoLastSlide(nextIndex, slideCount) {
      try {
        if (!this.isPlayDemoMode) return
        if (nextIndex == (slideCount - 1)) {
          const playedPresentationIds = this.currentUser.playedPresentationIds || []
          playedPresentationIds.push(this.$store.state.presentation.slides[nextIndex].id)
          UserApi.patchUserById(this.currentUser.id, {
            playedPresentationIds,
          })
          util.mixpanelTracking(
            'Presentation Edtior',
            'Live Demo > Finish Live Demo',
          )
        }
        let userTag = 'other'
        if (this.currentUser.personalInformation &&
          this.currentUser.personalInformation.useAhaSlidesFor) {
          userTag = this.currentUser.personalInformation.useAhaSlidesFor
        }
        util.mixpanelTracking(
          'Presentation Edtior',
          'Live demo > Change slide',
          userTag,
          nextIndex,
        )
      } catch (error) {
        Sentry.captureException(error)
      }
    },

    mobileExitFullScreen() {
      if (!this.isPresenting) return
      if (this.isZoomReady) {
        this.detachPresentationToZoomMeetingAction()
        this.$router.push({
          name: 'ZoomPresentationList',
        })
        return
      }
      util.setCurrentWindowMode()
      this.$router.replace({
        name: 'PresentationDetail',
        params: { id: this.$store.state.presentation.id },
      })
      this.$emit('hideFullScreen')
      util.mixpanelTracking(
        'Slide',
        'Mobile exit fullscreen',
        'Presenter switch to edit mode on mobile',
      )
    },
    openEditSlide() {
      this.$store.state.isOpenEditSlidePowerPoint = true
    },

    closeEdit() {
      if (this.$store.state.isNewPresentation) return
      this.$store.state.isOpenEditSlidePowerPoint = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.presenting-mode {
  &::v-deep {
    .transition-image-slide-bg {
      transition: background-image cubic-bezier(0.25, 1, 0.5, 1) 0.5s;
    }
    .slide-base-colour {
      transition: background-color cubic-bezier(0.25, 1, 0.5, 1) 0.5s;
    }
  }
  .slide-intro {
    margin: 0 auto;
    .main-slide {
      margin: 0 auto;
    }
  }
}
.audience-mode {
  padding-bottom: 16px;
  display: flex;
  justify-content: center;
}
.exit-wrapper {
  font-size: 86%;
  position: fixed;
  top: 3px;
  right: 4px;
  color: #fff;
  z-index: 160;
  display: none;
  cursor: pointer;
  .fas {
    padding-right: 5px;
  }
  @media (max-width: 768px) {
    display: block;
  }
}
.middle-presentation {
  position: relative;
  overflow-y: hidden;
  transition: all 0.3s ease;
}

.slide-intro {
  width: 100%;
  height: 100%;

  &::v-deep .main-slide {
    position: relative;
    margin: 0 0.75rem;
    overflow-y: hidden;
    overflow-x: hidden;
    box-shadow: 0px 10px 38px 0px #525F7F08;
    &.is-backstage {
      margin-top: 0.75rem;
    }
  }
}
.middle-presentation.presenting-mode {
  background-color: #000;
}

.middle-presentation {
  & ::v-deep .slide-intro {
    .slide-content {
      padding: 8px;
      &.ideas-slide-content {
        padding: 8px 19px;
      }
    }
    .title-slide {
      line-height: 1.2;
      word-break: break-word;
    }
  }
}

.wrap-slide-intro {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.is-backstage {
    margin-bottom: 24px;
  }
}

.middle-presentation.presenting-mode {
  overflow: hidden;
  background-color: #000;

  .wrap-slide-intro {
    background-color: #000;
    box-shadow: none;
    border-radius: 0;
    padding-top: initial;
    border: 0;
    height: 100%;
  }

  & ::v-deep .slide-intro {
    padding: 0;
    padding-bottom: 0;
    .main-slide {
      box-shadow: none;
      border-radius: 0;
      padding-top: initial;
      border: 0;
    }

    .top-header {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}

.middle-presentation.capture-mode {
  overflow-y: auto;
  overflow-x: hidden;
  -ms-overflow-style: auto;
}

//Set font size for shared presentation Iphone5/se
@media (max-width: 568px) and (orientation: landscape) {
  .shared__presentation-title {
    font-size: 13px;
  }
  .shared__copy-presentation .btn {
    font-size: 12px;
  }
}

#middle-take-over-toolbar.take-over {
  @apply my-0 mx-auto relative;
  width: calc(100% - 24px);
}

.playing-demo {
  &::v-deep .slide-control {
    opacity: 1;
  }
  &.middle-presentation {
    background-color: transparent;
  }

  &::v-deep .main-slide {
    border: 0 !important;
  }

  &::v-deep .slide-container {
    box-shadow: none;
  }

  .wrap-slide-intro {
    background-color: transparent !important;
  }
}

.middle-presentation {
  background: #f0f2f5;
  .slide-intro {
    &.screen-hd {
      font-size: 18px;
    }
  }
}

.powerpoint-middle {
  padding: 0 24px;
  margin: 0 auto;
  width: 100%;
  .item-ppt {
    width: 400px;
    text-align: center;
    @media (max-width: 1000px) {
      width: 500px;
    }
    @media (max-width: 873px) {
      width: 600px;
    }
  }
  &::v-deep {
    .limit-online-text {
      text-align: center;
    }
  }
}

.overlay-powerpoint-add-in {
  background-color: #0000002e;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.edit-slide-btn {
  display: inline-block;
}

.middle-ppt-full {
  z-index: 1;
  overflow-x: hidden;
}
</style>
